import { inject, Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class MFAService {
	private _http = inject(HttpClient);

	verify(code: string): Observable<boolean> {
		if (!code || code.length !== 6) {
			return of(false);
		}

		return this._http.post<any>(environment.api + '/client_portal/otp/', { otp: code }).pipe(
			map(() => true),
			catchError(() => of(false)),
		);
	}

	setup() {
		return this._http.get<any>(environment.api + '/client_portal/otp/').pipe(map((response) => response));
	}
}
